import { RESTAURANT } from "../lib/api";

const PARTNERS = [
  {
    key: "zomato",
    label: "Zomato Dining",
    sub: "Pay & save",
    href: RESTAURANT.links.zomato,
  },
  {
    key: "swiggy",
    label: "Swiggy Dineout",
    sub: "Discount on bill",
    href: RESTAURANT.links.swiggy,
  },
  {
    key: "eazydiner",
    label: "EazyDiner",
    sub: "Curated reservations",
    href: RESTAURANT.links.eazydiner,
  },
  {
    key: "whatsapp",
    label: "WhatsApp us",
    sub: "Reserve in a tap",
    href: RESTAURANT.links.whatsapp,
  },
];

export default function PartnersBar({ heading = true }) {
  return (
    <section
      data-testid="partners-bar"
      className="bg-[#1C2219]/40 py-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {heading && (
          <div className="mb-10 max-w-2xl">
            <div className="overline mb-3">Also available on</div>
            <h2 className="font-display text-3xl sm:text-4xl text-[#F9F6F0] leading-tight">
              Reserve with your preferred app — or with us, for the full 15% off.
            </h2>
          </div>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {PARTNERS.map((p) => (
            <a
              key={p.key}
              data-testid={`partner-${p.key}`}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group border border-[#2E3628] hover:border-[#D4C1A0] p-6 transition-colors flex flex-col justify-between min-h-[130px]"
            >
              <div className="overline text-[10px]">{p.sub}</div>
              <div className="mt-6 font-display text-xl text-[#F9F6F0] group-hover:text-[#D4C1A0] transition-colors">
                {p.label} →
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
